import { useContext } from "react";
import SystemContext from "./SystemContext";
const useSystemContext = () => {
    return useContext(SystemContext);
};
export default useSystemContext;
